import Env from '../base/env'
import Channels from '../base/channels'
import Draggable from 'gsap/Draggable'
import ThrowPropsPlugin from '../vendor/gsap-bonus/ThrowPropsPlugin';
import raf from 'raf'


export default class MoveFollow
{
    constructor(view)
    {
        this.view = view
        this.$collection = this.view.querySelector('.jsContext')
        this.$areaCollection = this.view.querySelector('.jsAreaContext')
        this.$items = this.view.querySelectorAll('.jsItem')
        this.$visual = this.$collection.querySelector('.visual')
        this.$cursor = this.view.querySelector('.jsCursor')
        // Popin
        this.$popin = this.view.querySelector('.jsPopin--view')
        this.$popinReceptor = this.$popin.querySelector('.jsReceptor')
        this.$popinClose = this.$popin.querySelector('.jsClose')
        this.POPIN_ENABLED = false
        this.timeoutPopinClean = false
        // Modes
        this.MOUSEMOVE_FOLLOW_MODE = true
        // Objects
        this.IS_DRAGGING = false
        this.bounds = {}
        this.instanceDrag = false
        this.raf = undefined
        this.RATE_EQ = 20
        this.FOLLOW_INERTIA = 1.5
        this.MOUSEX_DIRECTION = 0
        this.LIMIT_OFFSET_X = 75
        this.minX = 0
        // States
        this.mouseCoord = { x : 0 , y : 0 }
        this.newMouseCoord = { x : 0 , y : 0 }
        this.mouseDir = { x : 0 , y : 0 }
        this.distance = { x : 0 , y : 0 }
        this.dragDistance = { start : 0 , end : 0 , val : 0 }
        // Vars Cursor
        this.currentPositionCursor = { x : -500 , y : -500 }
        this.newPositionCursor = { x : 0 , y : 0 }
        this.inertia = 4
        // Fns
        this.funcResize = this.resize.bind(this)
    }

    configure()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const visualCoordinates = this.$visual.getBoundingClientRect()
        const maxX = visualCoordinates.width - viewport.width
        this.bounds = { minX : this.minX , maxX : maxX * -1 , minY : 0, maxY : 0 }
        TweenLite.set(this.$collection , {  x : this.minX })
        this.$areaCollection.style.width = `${visualCoordinates.width}px`
    }

    destroy()
    {

        Channels.removeListener('window::smartresize',this.funcResize)
        raf.cancel(this.raf)
    }

    draggable()
    {
        let settings = {}
        if(Env.mobileCSS == true) {
            settings.lock = true
            settings.type = "x"
            settings.dragResistance = .15
            settings.maxDuration = 1.5
        } else {
            settings.lock = false
            settings.type = "x"
            settings.dragResistance = .5
            settings.maxDuration = 1
        }
        this.configure()
        // Drag
        this.instanceDrag = Draggable.create(
            this.$collection,
            {
                cursor: 'grab',
                type:settings.type,
                edgeResistance:.99,
                dragResistance : settings.dragResistance,
                force3D : false,
                lockAxis : settings.lock,
                throwProps:true,
                minDuration:.5,
                maxDuration:settings.maxDuration,
                throwResistance: 3000,
                dragClickables : true,
                bounds : this.bounds,
                onDragStart:(e)=>{
                    this.IS_DRAGGING = true
                    this.$collection.classList.add('is--dragging')
                    this.dragDistance.start = e.x
                },
                onDrag:(e)=>{

                },
                onDragEnd:(e)=>{
                    this.$collection.classList.remove('is--dragging')
                    this.dragDistance.end = e.x
                    this.dragDistance.val = this.dragDistance.end - this.dragDistance.start
                },
                onThrowComplete:()=>{
                    this.IS_DRAGGING = false
                }
            }
        )
    }

    events()
    {
        Channels.on('window::smartresize',this.funcResize)

        this.view.addEventListener('mousemove',(e)=>
        {
            this.currentPositionCursor.x = e.clientX
            this.currentPositionCursor.y = e.clientY

            const
            viewport = Env.framework.toolbox.getViewport()
            ,contextWidth = viewport.width / 2
            ,contextHeight = viewport.height / 2

            this.mouseCoord.x = 1 - (e.clientX / contextWidth)
            this.mouseCoord.y = 1 - (e.clientY / contextHeight)
            this.mouseDir.x = 1 - (e.clientX / contextWidth)
            this.mouseDir.y = 1 - (e.clientY / contextHeight)

        })

        this.view.addEventListener('mouseenter',()=>{
            if(this.$cursor.classList.contains('is--active') === false) {
                this.$cursor.classList.add('is--active')
            }

        })
        this.view.addEventListener('mouseleave',()=>{
            if(this.$cursor.classList.contains('is--active') === true) {
                this.$cursor.classList.remove('is--active')
            }
        })

        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            $item.addEventListener('click',()=>{
                const status = $item.classList.contains('is--active')
                if(status == false) {
                    $item.classList.add('is--active')
                    setTimeout(() => {
                        this.popinOpen($item)
                    }, 200);
                } else {
                    $item.classList.remove('is--active')
                    this.popinClose()
                }

                return false
            })
            $item.addEventListener('mouseenter',()=>{
                const getText = $item.getAttribute('data-text')
                const getJob = $item.getAttribute('data-job')
                const getOpeningAlign = $item.getAttribute('data-opening') * 1
                this.$cursor.querySelector('.text').innerHTML = `<p><b>${getText}</b></p><p>${getJob}</p>`;
                this.$cursor.classList.add('is--hovered')
                if(getOpeningAlign) {
                    this.$cursor.classList.add('left--aligned')
                }
                const status = $item.classList.contains('is--active')
                if(status) {
                    this.$cursor.classList.add('is--opened')
                }
            })
            $item.addEventListener('mouseleave',()=>{
                this.$cursor.classList.remove('left--aligned')
                this.$cursor.classList.remove('is--hovered')
                this.$cursor.classList.remove('is--opened')
            })
        }

        this.$popinClose.addEventListener('click',()=>{
            if(this.POPIN_ENABLED == true) {
                this.popinClose()
            }
        })

    }

    popinClose()
    {
        this.resetBounds()
        this.$popin.classList.remove('is--active')
        this.$cursor.classList.remove('is--opened')
        this.view.classList.remove('popin--isOpened')
        this.view.classList.remove('popin--isSlided')
        this.POPIN_ENABLED = false
        this.MOUSEMOVE_FOLLOW_MODE = true
        this.timeoutPopinClean = setTimeout(() => {
            this.$popinReceptor.innerHTML = ''
        }, 500);
        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            $item.classList.remove('is--active')
        }
    }

    popinOpen($item)
    {
        clearTimeout(this.timeoutPopinClean)
        const html = $item.querySelector('.jsContent').innerHTML
        const getOpeningStatus = $item.getAttribute('data-opening')
        this.$popinReceptor.innerHTML = html
        this.$popin.classList.add('is--active')
        this.$cursor.classList.add('is--opened')


        if(getOpeningStatus == 1) {
            const status = this.view.classList.contains('popin--isOpened')
            if(status) {
                this.view.classList.add('popin--noTween')
                setTimeout(() => {
                    this.view.classList.remove('popin--noTween')
                }, 100);
                this.resetBounds()
            }
            this.view.classList.add('popin--isSlided')
        } else {
            this.updateBounds()
        }
        this.view.classList.add('popin--isOpened')

        this.POPIN_ENABLED = true
        this.MOUSEMOVE_FOLLOW_MODE = false
    }

    resetBounds()
    {
        this.instanceDrag[0].applyBounds({minX:this.bounds.minX, maxX:this.bounds.maxX , minY : 0, maxY : 0})
    }

    updateBounds()
    {
        const viewport = Env.framework.toolbox.getViewport()
        this.instanceDrag[0].applyBounds({minX:this.bounds.minX, maxX:this.bounds.maxX - (viewport.width * .3) , minY : 0, maxY : 0 })
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        if(Env.mobileCSS == false) {
            let getPosition;
            getPosition = this.$collection._gsTransform
            // Detect direction move
            if(this.newMouseCoord.x >= this.mouseDir.x) {
                this.MOUSEX_DIRECTION = 1
            } else {
                this.MOUSEX_DIRECTION = -1
            }
            // Limit Left / Right
            if(this.MOUSEMOVE_FOLLOW_MODE == true) {
                if((getPosition.x > (this.bounds.minX - this.LIMIT_OFFSET_X) && this.MOUSEX_DIRECTION == -1) || (getPosition.x < (this.bounds.maxX + this.LIMIT_OFFSET_X) && this.MOUSEX_DIRECTION == 1)) {
                    this.mouseCoord.x = 0
                }
            }
            this.newMouseCoord.x += (this.mouseCoord.x - this.newMouseCoord.x) / this.RATE_EQ
            this.newMouseCoord.y += (this.mouseCoord.y - this.newMouseCoord.y) / this.RATE_EQ
            // Set X Context
            if(this.IS_DRAGGING == false) {
                let distanceX,distanceY;
                distanceX = this.newMouseCoord.x * this.FOLLOW_INERTIA
                distanceY = this.newMouseCoord.y * this.FOLLOW_INERTIA

                let newXPosition,newYPosition
                if(this.MOUSEMOVE_FOLLOW_MODE == true) {
                    newXPosition = getPosition.x + distanceX
                    newYPosition = getPosition.y + distanceY
                    // Prevent White Space on Right when closing popin
                    if(newXPosition < this.bounds.maxX) {
                        newXPosition = this.bounds.maxX
                    }
                    TweenLite.set(this.$collection , { x  :  newXPosition  })

                }
            }

            // Cursor
            this.newPositionCursor.x += (this.currentPositionCursor.x - this.newPositionCursor.x) / this.inertia
            this.newPositionCursor.y += (this.currentPositionCursor.y - this.newPositionCursor.y) / this.inertia
            TweenLite.set(this.$cursor , { x : this.newPositionCursor.x , y : this.newPositionCursor.y })

        }
    }

    resize()
    {
        if(Env.mobileCSS == false) {
            this.instanceDrag[0].kill()
            this.instanceDrag = false
            TweenLite.set(this.$collection , { clearProps : 'all' })
            TweenLite.set(this.$collection , { x : 0 , width : 99999 })
            this.bounds = {}
            this.draggable()
        }
    }

    setup()
    {
        this.draggable()
        this.events()
        this.watcher()
    }

}


// WEBPACK FOOTER //
// ./resources/js/components/MoveFollow.js